module.exports = __webpack_public_path__ + "img/input_company_2.40325412.png";